import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import {
  bibShape,
  availabilityShape,
  branchShape,
  libraryShape,
  holdingShape,
  subscriptionShape,
  userIdentityShape
} from '@bibliocommons/bc-prop-types';
import BibsActions from 'app/actions/BibsActions';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectBibEntities, selectAvailabilityEntities } from 'app/selectors/EntitiesSelector';
import {
  selectAvailabilityError,
  selectBibItemsForCurrentBib,
  selectHoldingsForCurrentBib,
  selectSubscriptionsForCurrentBib
} from 'app/selectors/bibs/AvailabilitySelector';
import { selectAllDigitalFormats } from 'app/selectors/bibs/DigitalFormatsSelector';
import { selectCurrentLibrary, selectActivePreferredBranches } from 'app/selectors/LibrarySelector';
import { selectCurrentUser } from 'app/selectors/AuthSelector';

import TransactPanel from './TransactPanel';

export class TransactPanelContainer extends React.PureComponent {
  render() {
    return <TransactPanel {...this.props} />;
  }
}

TransactPanelContainer.propTypes = {
  bib: bibShape.isRequired,
  bibItems: ImmutablePropTypes.list.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  realtimeAvailability: availabilityShape,
  preferredBranches: ImmutablePropTypes.listOf(branchShape).isRequired,
  digitalFormats: ImmutablePropTypes.list,
  availabilityError: PropTypes.string,
  currentLibrary: libraryShape.isRequired,
  holdings: ImmutablePropTypes.listOf(holdingShape).isRequired,
  subscriptions: ImmutablePropTypes.listOf(subscriptionShape).isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentUser: userIdentityShape
};

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  const metadataId = catalogBib.get('metadataId');
  const bib = selectBibEntities(state).get(metadataId);
  const isAvailabilityLoaded = state.getIn(['bibs', 'availability', 'isLoaded'], false);
  const isTransactionsLoaded = state.getIn(['bibs', 'userTransactions', 'isLoaded'], false);

  return {
    bib,
    catalogBib,
    bibItems: selectBibItemsForCurrentBib(state),
    isLoaded: isAvailabilityLoaded && isTransactionsLoaded,
    realtimeAvailability: selectAvailabilityEntities(state).get(metadataId),
    digitalFormats: selectAllDigitalFormats(state).get(metadataId),
    preferredBranches: selectActivePreferredBranches(state),
    availabilityError: selectAvailabilityError(state),
    currentLibrary: selectCurrentLibrary(state),
    holdings: selectHoldingsForCurrentBib(state),
    subscriptions: selectSubscriptionsForCurrentBib(state),
    currentUser: selectCurrentUser(state)
  };
};

const mapDispatchToProps = dispatch => ({
  bibsActions: bindActionCreators(BibsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TransactPanelContainer);
